import { useEffect, useMemo, Fragment } from "react";
import { formatarNomeUpper } from "../../utils/formatadores";
import { useAdministrativo } from "../../hooks/useAdministrativo"; // Ajuste o path do hook

const GerenciamentoLogins = () => {
  const {
    logsLogins,
    loadingLogins,
    buscaLogins,
    setBuscaLogins,
    filtroActionLogins,
    setFiltroActionLogins,
    usuarioExpandidoLogins,
    carregarLogins,
    toggleExpandirLogins
  } = useAdministrativo();

  useEffect(() => {
    carregarLogins();
  }, [carregarLogins]);

  // Totais gerais calculados da lista bruta
  const totalLogins = logsLogins.filter((l) => l.action === "login").length;
  const totalLogouts = logsLogins.filter((l) => l.action === "logout").length;

  // Agrupamento dos registros por Usuário + Aplicação de Filtros
  const usuariosAgrupados = useMemo(() => {
    const mapa = new Map();

    logsLogins.forEach((item) => {
      // Filtragem por ação (login/logout)
      if (filtroActionLogins !== "todos" && item.action !== filtroActionLogins) {
        return;
      }

      const userId = item.userId || item.userNome || "desconhecido";

      if (!mapa.has(userId)) {
        mapa.set(userId, {
          userId,
          userNome: item.userNome,
          role: item.role,
          ultimoRegistro: item, // Considera que os logs retornados já vêm em ordem decrescente
          historico: []
        });
      }

      mapa.get(userId).historico.push(item);
    });

    return Array.from(mapa.values());
  }, [logsLogins, filtroActionLogins]);

  const renderBadgeAcao = (action) => (
    <span
      className={`badge ${action === "login" ? "badge-sucesso" : "badge-alerta"}`}
      style={{
        fontWeight: "bold",
        color: action === "login" ? "#2e7d32" : "#c62828"
      }}
    >
      {action === "login" ? "🔑 LOGIN" : "🚪 LOGOUT"}
    </span>
  );

  return (
    <div className="container-consulta-processos">
      <div className="card">
        <div className="agenda-header">
          <h1>GERENCIAMENTO DE LOGINS E LOGOUTS</h1>
        </div>

        <div className="agenda-indicadores">
          <div className="indicador">
            <h3>Total Logins</h3>
            <span>{totalLogins}</span>
          </div>

          <div className="indicador">
            <h3>Total Logouts</h3>
            <span>{totalLogouts}</span>
          </div>

          <div className="indicador">
            <h3>Usuários Exibidos</h3>
            <span>{usuariosAgrupados.length}</span>
          </div>

          <div className="indicador select-container">
            <h3>Filtrar por Ação</h3>
            <select
              value={filtroActionLogins}
              onChange={(e) => setFiltroActionLogins(e.target.value)}
              className="select-filtro"
            >
              <option value="todos">Todos os Eventos</option>
              <option value="login">Somente Logins</option>
              <option value="logout">Somente Logouts</option>
            </select>
          </div>
        </div>

        {/* BUSCA RÁPIDA DE USUÁRIO */}
        <div style={{ padding: "0 1rem 1rem 1rem" }}>
          <input
            type="text"
            placeholder="Buscar por nome ou cargo..."
            value={buscaLogins}
            onChange={(e) => setBuscaLogins(e.target.value)}
            className="select-filtro"
            style={{ width: "100%", maxWidth: "400px" }}
          />
        </div>

        <div className="table-container">
          <table className="table table-hover align-middle">
            <thead>
              <tr>
                <th style={{ width: "40px" }}></th>
                <th>Usuário</th>
                <th>Cargo / Perfil</th>
                <th>Última Ação</th>
                <th>Data / Hora (Último Acesso)</th>
                <th>Total Registros</th>
              </tr>
            </thead>
            <tbody>
              {loadingLogins ? (
                <tr>
                  <td colSpan="6" className="text-center empty-cell">
                    Carregando registros de acesso...
                  </td>
                </tr>
              ) : usuariosAgrupados.length > 0 ? (
                usuariosAgrupados.map((grupo, idx) => {
                  const keyUnica = grupo.userId ? `user-login-${grupo.userId}` : `user-login-idx-${idx}`;
                  const estaExpandido = usuarioExpandidoLogins === grupo.userId;
                  const ultimo = grupo.ultimoRegistro;

                  return (
                    <Fragment key={keyUnica}>
                      {/* Linha principal do Usuário */}
                      <tr
                        onClick={() => toggleExpandirLogins(grupo.userId)}
                        style={{ cursor: "pointer" }}
                        className="row-hover"
                      >
                        <td className="text-center">{estaExpandido ? "▼" : "▶"}</td>
                        <td>{formatarNomeUpper(grupo.userNome) || "-"}</td>
                        <td>{grupo.role ? grupo.role.toUpperCase() : "-"}</td>
                        <td>{renderBadgeAcao(ultimo?.action)}</td>
                        <td>
                          {ultimo?.dataHoraFormatada || ultimo?.createdAt || "-"}
                        </td>
                        <td>
                          <strong>{grupo.historico.length}</strong>
                        </td>
                      </tr>

                      {/* Histórico expandido de acessos do Usuário */}
                      {estaExpandido && (
                        <tr>
                          <td colSpan="6" className="p-3 bg-light">
                            <div className="table-responsive">
                              <table className="table table-sm table-bordered bg-white mb-0">
                                <thead>
                                  <tr>
                                    <th>Ação</th>
                                    <th>Data / Hora</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {grupo.historico.map((log, logIdx) => (
                                    <tr key={log._id || `log-${logIdx}`}>
                                      <td>{renderBadgeAcao(log.action)}</td>
                                      <td>
                                        {log.dataHoraFormatada || log.createdAt || "-"}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center empty-cell">
                    Nenhum registro de acesso encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GerenciamentoLogins;